var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLiveChat = function SvgLiveChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1693ac",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "800px",
    height: "800px",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5,21.9c-16.7,0-30,12.3-30,27.4c0,4.8,1.4,9.3,3.6,13.3c0.4,0.6,0.5,1.4,0.3,2.1l-3.9,10.7 c-0.4,1,0.6,1.9,1.6,1.6L32,72.9c0.6-0.3,1.4-0.1,2.1,0.3c4.5,2.5,9.9,4,15.7,4C66.2,77,79.6,64.9,79.6,49.6 C79.5,34.1,66.1,21.9,49.5,21.9z M34.5,54.5c-2.8,0-5-2.3-5-5c0-2.8,2.3-5,5-5c2.8,0,5,2.3,5,5S37.2,54.5,34.5,54.5z M49.5,54.5 c-2.8,0-5-2.3-5-5c0-2.8,2.3-5,5-5c2.8,0,5,2.3,5,5S52.3,54.5,49.5,54.5z M64.6,54.5c-2.8,0-5-2.3-5-5c0-2.8,2.3-5,5-5 c2.7,0,5,2.3,5,5S67.3,54.5,64.6,54.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLiveChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/liveChat.d011e377468f270512dacc78c4e068aa.svg";